<template>
  <v-container>
    <div class="d-flex flex-column">
      <div style="width: 100%" class="d-flex justify-space-between">
        <span class="d-flex headline font-weight-light"> Radovi (<p class="" style="color: var(--v-primary-base)"
                                                                    id="numberOf">{{ parseInt(this.getRegistarData.total) }}</p>)</span>
        <v-btn
            color="primary"
            v-show="getDeviceType != 'touch'"
            dark
            class="mb-2"
            @click="openDialog"
        >Dodaj rad
        </v-btn
        >
        <v-btn
            color="primary"
            v-show="getDeviceType === 'touch'"
            fab
            x-small
            elevation="0"
            dark
            class="mb-2"
            @click="openDialog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
      <div class="d-flex justify-space-between align-start" :class="$vuetify.breakpoint.mdAndUp?'':'flex-column'">
        <div :style="$vuetify.breakpoint.mdAndUp?'min-width: 400px; max-width: 800px':'width:100%'">
          <v-text-field
              dense
              outlined
              placeholder="Traži"
              v-model="searchRad"
              prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </div>
        <div class="d-flex flex-row justify-center align-center" v-if="hasAdminRights">
          <span>Verificiran:</span>
          <v-radio-group v-model="radioSelect" row>
            <v-radio label="Svi" value="2"></v-radio>
            <v-radio label="Da" value="1"></v-radio>
            <v-radio label="Ne" value="0" color="red"></v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
    <v-data-table
        :headers="headers"
        :loading="$wait.is('radovi')"
        :search="searchRad"
        :items="radovi"
        no-data-text="Nema podataka"
        no-results-text="Nema podataka"
        :items-per-page="getRegistarData.per_page"
        hide-default-footer
        @click:row="goToRad"
        class="elevation-1"
    >
      <template v-slot:[`item.verificiran`]="{ item }">
        <span v-if="item.verificiran == 1">DA</span>
        <span v-else>NE</span>
      </template>
      <template v-slot:[`item.sviAutori`]="{ item }">
        <div v-for="(autor, i) in item.sviAutori" :key="i">
          {{ autor.ime + ' ' + autor.prezime }}{{ item.sviAutori.length > 1 ? ', ' : '' }}
        </div>
      </template>
      <template v-slot:[`item.actions`]="{}">
        <v-icon small class="mr-2">mdi-chevron-right</v-icon>
      </template>
    </v-data-table>
    <v-dialog
        fullscreen
        v-model="editRadDialog"
        transition="dialog-bottom-transition"
    >
      <v-toolbar color="rgb(8, 71, 118)" flat v-if="selectedRad">
        <v-icon
            :disabled="$wait.is('verifikacija')"
            @click="closeDetails"
            class="mr-2"
            color="white"
        >mdi-close
        </v-icon
        >
        <h4 v-if="$vuetify.breakpoint.mdAndUp" style="color: white">
          {{ selectedRad.naslov }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
            :loading="$wait.is('verifikacija')"
            :small="getDeviceType === 'touch'"
            :icon="getDeviceType === 'touch'"
            @click="verification(selectedRad.id, selectedRad.verificiran === '1'? '0' : '1')"
            v-if="hasAdminRights"
            color="white"
            class="mr-2"
            :outlined="getDeviceType != 'touch'"
        >
          <v-icon v-if="selectedRad.verificiran === '0'">mdi-check</v-icon>
          <v-icon v-else>mdi-close</v-icon>
          <span v-if="getDeviceType === 'desktop'">{{
              selectedRad.verificiran === '1' ? 'Poništi verifikaciju' : 'Verificiraj'
            }}</span>
        </v-btn>

        <v-btn
            :disabled="$wait.is('verifikacija')"
            v-if="hasAdminRights"
            :small="getDeviceType === 'touch'"
            :icon="getDeviceType === 'touch'"
            color="white"
            class="mr-2"
            :outlined="getDeviceType != 'touch'"
            @click="editRad"
            :loading="$wait.is('setRadDetails')"
        >
          <v-icon>mdi-pencil</v-icon>
          <span v-if="getDeviceType === 'desktop'">Uredi</span>
        </v-btn>
        <v-btn
            :disabled="$wait.is('verifikacija')"
            v-if="hasAdminRights"
            :small="getDeviceType === 'touch'"
            :icon="getDeviceType === 'touch'"
            color="white"
            class="mr-2"
            :outlined="getDeviceType != 'touch'"
            @click="openDeleteDialog"
        >
          <v-icon>mdi-delete</v-icon>
          <span v-if="getDeviceType === 'desktop'">Izbriši</span>
        </v-btn>
      </v-toolbar>
      <detalji-rada></detalji-rada>
    </v-dialog>
    <v-dialog
        v-model="deleteDialog"
        persistent
        no-click-animation
        max-width="400"
        max-height="500"
        style="z-index: 9000000"
    >
      <v-card :loading="$wait.is('deleteRad')">
        <v-card-title class="headline">Izbriši rad</v-card-title>
        <v-card-text>Da li ste sigurni da želite izbrisati rad?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary darken-1"
              text
              :disabled="$wait.is('deleteRad')"
              @click="deleteDialog = false"
          >Ne
          </v-btn
          >
          <v-btn
              color="red darken-1"
              :disabled="$wait.is('deleteRad')"
              text
              @click="Delete"
          >Izbriši
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center pt-2">
      <v-pagination
          v-model="page"
          @input="goTo"
          :length="getRegistarData.last_page"
          total-visible="20"
      ></v-pagination>
    </div>
    <v-dialog
        v-model="noviRadDialog"
        fullscreen
        transition="dialog-bottom-transition"
    >
      <v-card :loading="$wait.is('radAction')">
        <v-toolbar style="background-color: rgb(8, 71, 118); color: white">
          <v-icon class="mr-5" @click="closeCreateDialog" color="white"
          >mdi-close
          </v-icon
          >
          <span v-if="!isInEdit">Novi rad</span>
          <span v-else>Uređivanje rada</span>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="!isValid"
              v-if="!isInEdit"
              outlined
              color="white"
              @click="creatNew"
              :loading="$wait.is('radAction')"
          >Dodaj rad
          </v-btn
          >
          <v-btn
              :disabled="!isValid"
              v-show="hasAdminRights"
              v-else
              outlined
              color="white"
              @click="edit"
              :loading="$wait.is('radAction')"
          >Uredi rad
          </v-btn
          >
        </v-toolbar>

        <v-container :class="!$vuetify.breakpoint.mdAndUp ? 'mb-10' : ''">
          <v-stepper v-model="openStep" elevaion="0" alt-labels>
            <v-stepper-header v-if="$vuetify.breakpoint.mdAndUp" elevaion="0">
              <v-stepper-step
                  :complete="openStep > 1"
                  step="1"
                  :editable="openStep > 1"
              ><p class="text-center">Detalji o radu</p></v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                  :complete="openStep > 2 && hasType"
                  step="2"
                  :editable="isValid && hasType"
              ><p class="text-center">Detalji o izdanju</p>
                <small style="color: red" v-if="!hasType"
                >Nije moguće odabrati</small
                ></v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step
                  :complete="openStep > 2"
                  step="3"
                  :editable="isValid"
              >
                <p class="text-center">Znanstvena područja</p></v-stepper-step
              >

              <v-divider></v-divider>
              <v-stepper-step
                  :complete="openStep > 3"
                  step="4"
                  :editable="isValid"
              >
                <p class="text-center">Detalji o autorima</p>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                  :complete="openStep > 4"
                  step="5"
                  :editable="isValid"
              ><p class="text-center">Dodavanje rada</p></v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <form-one
                    v-on:setSelectedTip="selectTip"
                    :noviRadDialog="noviRadDialog"
                    :types="types"
                    :details="details"
                    :isInEdit="isInEdit"
                    :selectedRad="selectedRad"
                ></form-one>

                <v-btn
                    :disabled="!isValid"
                    color="primary"
                    @click="nextStep"
                    class="ml-4"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >Dalje
                </v-btn
                >
              </v-stepper-content>

              <v-stepper-content step="2">
                <form-three
                    v-if="getTip"
                    :editions="editions"
                    :types="types"
                ></form-three>
                <v-btn
                    color="primary"
                    class="ml-4"
                    @click="openStep = 3"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >Dalje
                </v-btn
                >
              </v-stepper-content>

              <v-stepper-content step="3">
                <form-four :currentStep="openStep"></form-four>
                <v-btn
                    color="primary"
                    class="ml-4"
                    @click="openStep = 4"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >Dalje
                </v-btn
                >
              </v-stepper-content>

              <v-stepper-content step="4">
                <form-five :authors="authors"></form-five>
                <v-btn
                    color="primary"
                    class="ml-4"
                    @click="openStep = 5"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >Dalje
                </v-btn
                >
              </v-stepper-content>

              <v-stepper-content step="5">
                <form-six
                    :links="links"
                    :noviRadDialog="noviRadDialog"
                    :isInEdit="isInEdit"
                    :selectedRad="selectedRad"
                ></form-six>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>

        <v-bottom-navigation
            v-if="!$vuetify.breakpoint.mdAndUp"
            style="position: fixed"
        >
          <v-sheet
              style="width: 100%"
              class="d-flex justify-space-between align-center"
          >
            <div>
              <v-btn
                  :disabled="openStep == 1"
                  @click="stepBack"
                  color="primary"
                  class="d-flex"
                  icon
              >
                <span><v-icon>mdi-chevron-left</v-icon>Nazad</span>
              </v-btn>
            </div>
            <div>
              <v-icon
                  size="15"
                  class="pa-0"
                  v-for="s in 5"
                  :key="s"
                  :disabled="(s === 2 && !getTip) || !isValid"
                  @click="openStep = s"
                  :color="openStep == s ? 'primary' : 'grey'"
              >
                mdi-record
              </v-icon>
            </div>
            <div>
              <v-btn
                  :disabled="openStep == 5 || !isValid"
                  @click="nextStep"
                  color="primary"
                  class="d-flex"
                  icon
              >
                <span>Dalje<v-icon>mdi-chevron-right</v-icon></span>
              </v-btn>
            </div>
          </v-sheet>
        </v-bottom-navigation>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {waitFor} from "vue-wait";
import {mapGetters} from "vuex";
import _ from "lodash";
import axios from "axios";

export default {
  data: () => ({
    noviRadDialog: false,
    openStep: 1,
    editRadDialog: false,
    radioGroup: "2",
    dialog: false,
    details: {},
    types: {},
    editions: {},
    authors: {},
    page: 1,
    deleteDialog: false,
    links: {},
    selectedRad: null,
    headers: [
      {
        text: "Naslov",
        value: "naslov",
        sortable: true,
      },
      {
        text: "Tip rada",
        value: "vrsta_rada",
        sortable: false,
      },
      {
        text: "Verificiran",
        value: "verificiran",
        sortable: false,
      },
      {
        text: "Autori",
        value: "sviAutori",
        sortable: false,
      },
      {
        text: "",
        value: "actions",
        align: "end",
        sortable: false,
      },
    ],
    editedIndex: -1,
    search: "",
    isInEdit: false,
  }),

  computed: {
    ...mapGetters([
      "getVerificiran",
      "getOdabraniRad",
      "getDokumenti",
      "getNoviRad",
      "getTip",
      "getVrsta",
      "getJezici",
      "getNovaVrsta",
      "getDoi",
      "getDatumIzlozbe",
      "getDatumObrane",
      "getIssn",
      "getIsbn",
      "getBroj",
      "getMjesto_izdavanja",
      "getUrednik",
      "getRelevantnost",
      "getZnanstvena_publikacija",
      "getLinkovi",
      "getNovoIzdanje",
      "getOdabraneKljucneRijeci",
      "getSelectedPodrucja",
      "getRegistarData",
      "hasAdminRights",
      "getDeviceType",
      "getOdabraniUposleniciAutori",
      "getOdabraniStudentAutori",
      "getOdabraniStraniAutori",
      "getAllVrsteRada",
      "getKreiranoIzdanje",
      "getPrevodi",
      "getVrstaRada",
      "getFileIds",
      "getVrificiran",
      "getSvaZnanstvenaPodrucja",
    ]),
    isValid() {
      if (this.getTip?.tip_izdanja && this.getTip.tip_izdanja.naziv === 'Knjiga')
        return (
            this.getNoviRad.naziv != "" &&
            this.getNoviRad.naziv != null &&
            this.getNoviRad.godina != "" &&
            this.getNoviRad.godina != null
        );
      else
        return (
            this.getNoviRad.naziv != "" &&
            this.getNoviRad.naziv != null &&
            this.getNoviRad.godina != "" &&
            this.getNoviRad.godina != null &&
            this.getNoviRad.sazetak != "" &&
            this.getNoviRad.sazetak != null
        );
    },
    radioSelect: {
      set(value) {
        if (value) {
          this.radioGroup = value;
          waitFor("radovi", async function () {
            if (value < 2) {
              await this.$store.dispatch("getRegistar", {
                page: 1,
                search: this.searchRad,
                verificiran: value,
              });
            } else {
              await this.$store.dispatch("getRegistar", {
                page: 1,
                search: this.searchRad,
                verificiran: "",
              });
            }
          }).apply(this);
        }
      },
      get() {
        return this.radioGroup;
      },
    },
    radovi() {
      let radovi = [];
      let vrstaRada = null;
      if (this.getRegistarData.data && this.getAllVrsteRada.length > 0) {
        this.getRegistarData.data.forEach((rad) => {
          if (
              this.getAllVrsteRada.find((vrsta) => rad.vrsta_rada_id == vrsta.id)
          ) {
            vrstaRada = this.getAllVrsteRada.find(
                (vrsta) => rad.vrsta_rada_id == vrsta.id
            ).naziv;
          }
          if (vrstaRada) {
            Object.assign(rad, {
              vrsta_rada: vrstaRada,
            });
          } else {
            Object.assign(rad, {
              vrsta_rada: "-",
            });
          }
          radovi.push(rad);
          vrstaRada = null;
        });
      }
      return radovi;
    },
    searchRad: {
      set(value) {
        if (value != this.search) {
          this.search = value;
          waitFor("radovi", async function () {
            await this.$store.dispatch("getRegistar", {
              page: 1,
              search: value,
              verificiran: "",
            });
          }).apply(this);
        }
      },
      get() {
        return this.search;
      },
    },
    hasType() {
      // console.log(this.getTip)
      if (this.getTip) {
        if (this.getTip?.tip_izdanja) {
          if (this.getTip.tip_izdanja.naziv === 'Knjiga')
            return false
          else
            return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    openStep(value) {
      if (value == 2) {
        waitFor("getTipovi", async function () {
          await this.$store.dispatch("getIzdanjaByTip", {
            id: this.getTip.tip_izdanja_id,
          });
        }).apply(this);
      }
    },
  },
  methods: {
    animateValue(start, end, duration) {
      if (start === end) return;
      var range = end - start;
      var current = start;
      var increment = end > start ? 10 : -50;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.getElementById('numberOf');
      if (obj) {
        var timer = setInterval(function () {
          current += increment;
          // console.log(start, end, duration,current)
          obj.innerHTML = current;
          if (current == end) {
            clearInterval(timer);
          }
        }, stepTime);
      } else {
        clearInterval(timer);
      }
    },
    async closeDetails() {
      this.editRadDialog = false;
      this.isInEdit = false;
    },
    async closeCreateDialog() {
      this.noviRadDialog = false;
      this.openStep = 1;
      await this.$store.dispatch("removeSelectedData");
    },
    openDeleteDialog() {
      this.deleteDialog = true;
    },
    editRad() {
      waitFor("setRadDetails", async function () {
        await this.$store.dispatch("setRadDetails", this.getOdabraniRad);
        this.isInEdit = true;
        this.noviRadDialog = true;
      }).apply(this);
    },
    async Delete() {
      waitFor("deleteRad", async function () {
        if (this.getOdabraniRad.uposlenici_autori.length) {
          await this.$store.dispatch("detachuposleniciAutori", {
            id: this.selectedRad.id,
            ids: this.getOdabraniRad.uposlenici_autori.map((p) =>
                parseInt(p.id)
            ),
          });
        }
        if (this.getOdabraniRad.strani_autori.length) {
          await this.$store.dispatch("detachstraniAutori", {
            id: this.selectedRad.id,
            ids: this.getOdabraniRad.strani_autori.map((p) => parseInt(p.id)),
          });
        }
        if (this.getOdabraniRad.studenti_autori.length) {
          await this.$store.dispatch("detachstudentiAutori", {
            id: this.selectedRad.id,
            ids: this.getOdabraniRad.studenti_autori.map((p) => parseInt(p.id)),
          });
        }
        if (this.getOdabraniRad.linkovi.length) {
          await this.$store.dispatch("detachlinkovi", {
            id: this.selectedRad.id,
            // ids: this.getOdabraniRad.linkovi.map((p) => parseInt(p.id)),
          });
        }
        if (this.getOdabraniRad.dokumenti_rada.length) {
          await this.$store.dispatch("detachdokumenti", {
            id: this.selectedRad.id,
            //ids: this.getOdabraniRad.dokumenti_rada.map((p) => parseInt(p.id)),
          });
        }
        // if(this.getOdabraniRad.izdanje_id){
        //   await this.$store.dispatch("detachizdanje", {
        //     id: this.selectedRad.id,
        //     ids: [parseInt(this.getOdabraniRad.izdanje_id)],
        //   });
        // }
        // if (this.getOdabraniRad.vrsta_rada_id) {
        //   await this.$store.dispatch("detachvrstaRada", {
        //     id: this.selectedRad.id,
        //     ids: [this.getOdabraniRad.vrsta_rada_id],
        //   });
        // }
        if (this.getOdabraniRad.kljucne_rijeci.length) {
          await this.$store.dispatch("detachKljucneRijeci", {
            id: this.selectedRad.id,
            ids: this.getOdabraniRad.kljucne_rijeci.map((p) => parseInt(p.id)),
          });
        }
        if (this.getOdabraniRad.znanstvena_podrucja.length)
          await this.$store.dispatch("detachznanstvenaPodrucja", {
            id: this.selectedRad.id,
            ids: this.getOdabraniRad.znanstvena_podrucja.map((p) =>
                parseInt(p.id)
            ),
          });
        if (this.getOdabraniRad.prijevodi.length) {
          await this.$store.dispatch("detachPrijevodi", {
            id: this.selectedRad.id,
            // ids: this.getOdabraniRad.prijevodi.map((p) => p.id),
          });
        }
        await this.$store
            .dispatch("deleteRad", this.selectedRad.id)
            .then(() => {
              this.selectedRad = {};
              waitFor("radovi", async function () {
                if (this.radioSelect < 2) {
                  await this.$store.dispatch("getRegistar", {
                    page: 1,
                    search: this.searchRad,
                    verificiran: this.radioSelect,
                  });
                } else {
                  await this.$store.dispatch("getRegistar", {
                    page: 1,
                    search: this.searchRad,
                    verificiran: "",
                  });
                }
              }).apply(this);
              this.deleteDialog = false;
              this.editRadDialog = false;
            });
      }).apply(this);
    },
    async verification(id, confirm) {
      let params = {
        confirm: confirm
      }
      axios.post(`/registar_v2/radovi/${id}/confirm`, params).then(response => {
        let resCode = response.status
        if(resCode === 200 || resCode === 201) {
          this.$store.dispatch('getNotification', {
            state: true,
            color: 'green',
            text: confirm === '1' ? 'Rad uspješno verificiran' : 'Uspješno poništena verifikacija rada'
          })
        } else if(resCode === 404) {
          this.$store.dispatch('getNotification', {
            state: true,
            color: 'red',
            text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
          })
        } else if(resCode === 500) {
          this.$store.dispatch('getNotification', {
            state: true,
            color: 'red',
            text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
          })
        }
        // waitFor("verifikacija", async function () {
          if (response) {
            Object.assign(this.selectedRad, {verificiran: response?.verificiran});
          }
        // }).apply(this);

        this.editRadDialog = false;
        this.selectedRad = null
      }).finally( () => {
        this.radioGroup = this.radioSelect;
        waitFor("radovi", async function () {
          if (this.radioGroup < 2) {
            await this.$store.dispatch("getRegistar", {
              page: 1,
              search: this.searchRad,
              verificiran: this.radioGroup,
            });
          } else {
            await this.$store.dispatch("getRegistar", {
              page: 1,
              search: this.searchRad,
              verificiran: "",
            });
          }
        }).apply(this);
      })
    },
    verificirajRad() {
      let noviRad = {};
      let relations = {};
      let autori = {}
      Object.assign(noviRad, {
        naslov: this.getOdabraniRad.naslov,
        sazetak: this.getOdabraniRad.sazetak,
        godina: this.getOdabraniRad.godina,
      });
      if (this.getOdabraniRad.vrsta_rada_id) {
        Object.assign(noviRad, {
          vrsta_rada_id: this.getOdabraniRad.vrsta_rada_id,
        });
      }
      if (this.getOdabraniRad.izdanje_id) {
        Object.assign(noviRad, {
          izdanje_id: this.getOdabraniRad.izdanje_id,
        });
      }
      Object.assign(noviRad, {
        id: this.getOdabraniRad.id,
      });
      Object.assign(noviRad, {
        verificiran: 1,
      });
      let kljucne_rijeci = {
        method: "sync",
      };
      // let linkovi = {
      //   method: "sync",
      // };
      if (this.getOdabraniRad.kljucne_rijeci.length > 0) {
        Object.assign(kljucne_rijeci, {
          method: "sync",
        });
        let data = [];
        this.getOdabraniRad.kljucne_rijeci.forEach((kr) => {
          data.push(kr.id);
        });

        Object.assign(kljucne_rijeci, {
          data: data,
        });
        Object.assign(relations, {
          kljucneRijeci: kljucne_rijeci,
        });
      }
      // if (this.getOdabraniRad.linkovi.length > 0) {
      //   let data = [];
      //   this.getOdabraniRad.linkovi.forEach((link) => {
      //     data.push({
      //       opis_linka: link.opis_linka,
      //       link: link.link,
      //     });
      //   });
      //   Object.assign(linkovi, {
      //     data: data,
      //   });
      //   Object.assign(relations, {
      //     linkovi: linkovi,
      //   });
      // }
      if (this.getOdabraniRad.doi && this.getOdabraniRad.doi !== "") {
        Object.assign(noviRad, {
          doi: this.getOdabraniRad.doi,
        });
      }
      if (
          this.getOdabraniRad.datum_izlozbe &&
          this.getOdabraniRad.datum_izlozbe !== ""
      ) {
        Object.assign(noviRad, {
          datum_izlozbe: this.getOdabraniRad.datum_izlozbe,
        });
      }
      if (
          this.getOdabraniRad.mjesto_izlozbe &&
          this.getOdabraniRad.mjesto_izlozbe !== ""
      ) {
        Object.assign(noviRad, {
          mjesto_izlozbe: this.getOdabraniRad.mjesto_izlozbe,
        });
      }
      if (
          this.getOdabraniRad.datum_obrane &&
          this.getOdabraniRad.datum_obrane !== ""
      ) {
        Object.assign(noviRad, {
          datum_obrane: this.getOdabraniRad.datum_obrane,
        });
      }
      if (this.getOdabraniRad.godiste && this.getOdabraniRad.godiste !== "") {
        Object.assign(noviRad, {
          datum_obrane: this.getOdabraniRad.godiste,
        });
      }
      if (
          this.getOdabraniRad.vrste_rada_id &&
          this.getOdabraniRad.vrste_rada !== ""
      ) {
        Object.assign(noviRad, {
          vrsta_rada_id: this.getOdabraniRad.vrste_rada_id,
        });
      }
      if (this.getOdabraniRad.znanstvena_podrucja.length > 0) {
        let znanstvenaPodrucja = {
          method: "sync",
        };
        let data = [];
        this.getOdabraniRad.znanstvena_podrucja.forEach((zp) => {
          data.push(zp.id);
        });
        Object.assign(znanstvenaPodrucja, {
          data: data,
        }),
            Object.assign(relations, {
              znanstvenaPodrucja: znanstvenaPodrucja,
            });
      }
      if (this.getOdabraniRad.uposlenici_autori.length > 0) {
        let authors = {};
        this.getOdabraniRad.uposlenici_autori.forEach((autor) => {
          let autorId = {
            poredak: autor.pivot.poredak,
          };
          authors[`${autor.id}`] = autorId;
        });
        let uposleniciAutori = {
          method: "sync",
          data: authors,
        };
        // Object.assign(relations, {
        //   uposleniciAutori: uposleniciAutori,
        // });
        Object.assign(autori, {
          uposleniciAutori: uposleniciAutori,
        });
      }
      if (this.getOdabraniRad.strani_autori.length > 0) {
        let authors = {};
        this.getOdabraniRad.strani_autori.forEach((autor) => {
          let autorId = {
            poredak: autor.pivot.poredak,
          };
          authors[`${autor.id}`] = autorId;
        });
        let straniAutori = {
          method: "sync",
          data: authors,
        };
        // Object.assign(relations, {
        //   straniAutori: straniAutori,
        // });
        Object.assign(autori, {
          straniAutori: straniAutori,
        });
      }
      if (this.getOdabraniRad.studenti_autori.length > 0) {
        let authors = {};
        this.getOdabraniRad.studenti_autori.forEach((autor) => {
          let autorId = {
            poredak: autor.pivot.poredak,
          };
          authors[`${autor.id}`] = autorId;
        });
        let studentAutori = {
          method: "sync",
          data: authors,
        };
        // Object.assign(relations, {
        //   studentiAutori: studentAutori,
        // });
        Object.assign(autori, {
          studentiAutori: studentAutori,
        });
      }
      // if (this.getOdabraniRad.prijevodi.length > 0) {
      //   let prijevodiRada = {
      //     method: "sync",
      //     data: this.getOdabraniRad.prijevodi,
      //   };
      //   Object.assign(relations, {
      //     prijevodi: prijevodiRada,
      //   });
      // }
      // if (this.getOdabraniRad.dokumenti_rada.length) {
      //   let data = [];
      //   this.getOdabraniRad.dokumenti_rada.forEach((dr) => {
      //     data.push(dr.id);
      //   });
      //   Object.assign(relations, {
      //     dokumentiRada: {
      //       method: "sync",
      //       data: data,
      //     },
      //   });
      // }
      Object.assign(noviRad, {
        relations: relations,
      });
      Object.assign(noviRad, {
        autori: autori,
      });
      waitFor("verifikacija", async function () {
        await this.$store.dispatch("verificirajRad", noviRad).then((res) => {
          if (res) {
            Object.assign(this.selectedRad, {verificiran: res?.verificiran});
          }
        });
      }).apply(this);
    },
    goToRad(rad) {
      console.log(rad)
      this.selectedRad = rad;
      waitFor("getRadDetails", async function () {
        await this.$store.dispatch("fetchRad", rad.id);
      }).apply(this);

      this.editRadDialog = true;
    },
    selectTip(tip) {
      this.types.selectedType = tip;
    },
    async goTo(item) {
      this.page = item;
      waitFor("radovi", async function () {
        if (this.radioSelect < 2) {
          await this.$store.dispatch("getRegistar", {
            page: item,
            search: this.searchRad,
            verificiran: this.radioSelect,
          });
        } else {
          await this.$store.dispatch("getRegistar", {
            page: item,
            search: this.searchRad,
            verificiran: "",
          });
        }
      }).apply(this);
    },
    openDialog() {
      this.noviRadDialog = true;
      waitFor("getTypesFilter", async function () {
        await this.$store.dispatch("getTypesFilter");
        await this.$store.dispatch("getJezici");
        await this.$store.dispatch("getUposlenici");
        await this.$store.dispatch("getOsobe");
        await this.$store.dispatch("getAkademskiStupnjevi");
        await this.$store.dispatch("getZvanja");
      }).apply(this);
    },

    stepBack() {
      if (this.openStep > parseInt(3) || this.openStep == 2) {
        this.openStep--;
      } else if (this.getTip) {
        if (this.getTip?.tip_izdanja) {
          if (this.openStep == 3) {
            this.openStep = "2";
          }
        }
      } else {
        if (this.openStep == 3) {
          this.openStep = "1";
        }
      }
    },
    nextStep() {
      if (this.getTip && this.openStep == 1) {
        if (this.getTip?.tip_izdanja) {
          if (this.getTip.tip_izdanja.naziv === 'Knjiga')
            this.openStep = 3;
          else
            this.openStep = 2;
        } else {
          this.openStep = 3;
        }
      } else {
        if (this.openStep == 4 && this.isInEdit) {
          this.$store.dispatch("setDokumenti", this.selectedRad.dokumenti_rada);
          this.openStep = 5;
        } else if (this.openStep == 1) {
          this.openStep = 3;
        } else {
          this.openStep++;
        }
      }
    },
    async creatNew() {
      let noviRad = {};
      let relations = {};
      let autori = {}
      Object.assign(noviRad, {
        naslov: this.getNoviRad.naziv,
        sazetak: this.getNoviRad.sazetak,
        godina: this.getNoviRad.godina,
        verificiran: this.hasAdminRights ? "1" : "0",
      });
      if (this.getVrsta) {
        Object.assign(noviRad, {vrsta_rada_id: this.getVrsta.id});
      }
      if (this.getKreiranoIzdanje) {
        Object.assign(noviRad, {
          izdanje_id: this.getKreiranoIzdanje.id,
        });
      }

      let kljucne_rijeci = {
        method: "createMany",
      };
      let linkovi = {
        method: "createMany",
      };
      if (this.getOdabraneKljucneRijeci.length > 0) {
        Object.assign(kljucne_rijeci, {
          method: "attach",
        });
        let data = [];
        this.getOdabraneKljucneRijeci.forEach((kr) => {
          data.push(kr.id);
        });

        Object.assign(kljucne_rijeci, {
          data: data,
        });
        Object.assign(relations, {
          kljucneRijeci: kljucne_rijeci,
        });
      }
      if (this.getLinkovi && this.getLinkovi.length) {
        let data = [];
        this.getLinkovi.forEach((link) => {
          data.push({
            opis_linka: link.opis_linka,
            link: link.link,
          });
        });
        Object.assign(linkovi, {
          data: data,
        });
        Object.assign(relations, {
          linkovi: linkovi,
        });
      }
      if (this.getNovoIzdanje) {
        let izdanje = {
          method: "create",
          data: {
            naziv: this.getNovoIzdanje.name,
            issn: this.getNovoIzdanje.issn,
            isbn: this.getNovoIzdanje.isbn,
          },
        };
        if (this.getNovoIzdanje.issn !== "0" && this.getIssn !== "") {
          Object.assign(noviRad, {
            issn: this.getIssn,
          });
        }
        if (this.getNovoIzdanje.isbn !== "0" && this.getIsbn !== "") {
          Object.assign(noviRad, {
            isbn: this.getIsbn,
          });
        }
        if (
            this.getNovoIzdanje.mjesto_izdavanja !== "0" &&
            this.getMjesto_izdavanja !== ""
        ) {
          Object.assign(noviRad, {
            mjesto_izdavanja: this.getMjesto_izdavanja,
          });
        }
        if (this.getNovoIzdanje.urednik !== "0" && this.getUrednik !== "") {
          Object.assign(noviRad, {
            urednik: this.getUrednik,
          });
        }
        if (this.getNovoIzdanje.broj !== "0" && this.getBroj !== "") {
          Object.assign(noviRad, {
            broj: this.getBroj,
          });
        }
        if (
            this.getNovoIzdanje.relevantnost !== "0" &&
            this.getRelevantnost !== ""
        ) {
          Object.assign(noviRad, {
            relevantnost: this.getRelevantnost,
          });
        }
        if (
            this.getNovoIzdanje.znanstvena_publikacija !== "0" &&
            this.getZnanstvena_publikacija !== ""
        ) {
          Object.assign(noviRad, {
            znanstvena_publikacija: this.getZnanstvena_publikacija,
          });
        }
        Object.assign(relations, {
          izdanje: izdanje,
        });
      }
      if (this.getTip) {
        if (this.getTip.doi && this.getDoi !== "") {
          Object.assign(noviRad, {
            doi: this.getDoi,
          });
        }
        if (this.getTip.datum_izlozbe && this.getDatumIzlozbe !== "") {
          Object.assign(noviRad, {
            datum_izlozbe: this.getDatumIzlozbe,
          });
        }
        if (this.getTip.mjesto_izlozbe && this.getMjestoIzlozbe !== "") {
          Object.assign(noviRad, {
            mjesto_izlozbe: this.getMjestoIzlozbe,
          });
        }
        if (this.getTip.datum_obrane && this.getDatumObrane !== "") {
          Object.assign(noviRad, {
            datum_obrane: this.getDatumObrane,
          });
        }
      }
      if (this.getSelectedPodrucja.length > 0) {
        let znanstvenaPodrucja = {
          method: "attach",
        };
        let parents = [];
        let singleChildrenIds = [];
        this.getSelectedPodrucja.forEach((podrucje) => {
          if (Object.prototype.hasOwnProperty.call(podrucje, "children")) {
            if (podrucje.children.length > 0 && !parents.includes(podrucje)) {
              parents.push(podrucje);
            }
          }
        });
        let parentIds = [];
        for (let i = 0; i < parents.length; i++) {
          for (let y = 0; y < parents.length; y++) {
            if (parents[i].id != parents[y].pripada_id) {
              if (!parentIds.includes(parents[i].id)) {
                parentIds.push(parents[i].id);
              }
            }
          }
        }
        this.getSelectedPodrucja.forEach((podrucje) => {
          if (
              !parentIds.includes(podrucje.id) &&
              !parentIds.includes(parseInt(podrucje.pripada_id))
          ) {
            singleChildrenIds.push(podrucje.id);
          }
        });

        let data = parentIds.concat(singleChildrenIds);
        Object.assign(znanstvenaPodrucja, {
          data: data,
        }),
            Object.assign(relations, {
              znanstvenaPodrucja: znanstvenaPodrucja,
            });
      }
console.log(this.getOdabraniUposleniciAutori)
      if (this.getOdabraniUposleniciAutori.length > 0) {
        let authors = {};
        this.getOdabraniUposleniciAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          Object.assign(authors, {
            [autor.id]: autorId,
          });
          // authors.push({
          //   uposlenik_autor_id: autor.id,
          //   poredak: autor.redBr,
          // });
        });
        let uposleniciAutori = {
          method: "attach",
          data: authors,
        };
        //  uposleniciAutori, 'uposleniciAut')
        // Object.assign(relations, {
        //   uposleniciAutori: uposleniciAutori,
        // });
        Object.assign(autori, {
          uposleniciAutori: uposleniciAutori,
        });
      }
      if (this.getOdabraniStudentAutori.length > 0) {
        let authors = {};
        this.getOdabraniStudentAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          // authors.push({
          //   strani_autor_id: autor.id,
          //   poredak: autor.redBr,
          // });
          Object.assign(authors, {
            [autor.id]: autorId,
          });
        });
        let studentAutori = {
          method: "attach",
          data: authors,
        };

        // Object.assign(relations, {
        //   studentiAutori: studentAutori,
        // }); 
        Object.assign(autori, {
          studentiAutori: studentAutori,
        });
      }
      if (this.getOdabraniStraniAutori.length > 0) {
        let authors = {};
        this.getOdabraniStraniAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          Object.assign(authors, {
            [autor.id]: autorId,
          });
          // authors.push({
          //   strani_autor_id: autor.id,
          //   poredak: autor.redBr,
          // });
        });
        let straniAutori = {
          method: "attach",
          data: authors,
        };

        // Object.assign(relations, {
        //   straniAutori: straniAutori,
        // });
        Object.assign(autori, {
          straniAutori: straniAutori,
        });
      }
      if (this.getPrevodi.length > 0) {
        let prijevodiRada = {
          method: "createMany",
          data: this.getPrevodi,
        };

        Object.assign(relations, {
          prijevodi: prijevodiRada,
        });
      }
      if (this.getFileIds.length) {
        Object.assign(relations, {
          dokumenti: {method: "attach", data: this.getFileIds},
        });
      }
      Object.assign(noviRad, {
        relations: relations,
      });
      Object.assign(noviRad, {
        autori: autori,
      });
      console.log(noviRad)
      waitFor("radAction", async function () {
        this.$store.dispatch("createNewRad", noviRad).then(async () => {
          if (this.radioSelect < 2) {
            await this.$store.dispatch("getRegistar", {
              page: 1,
              search: this.searchRad,
              verificiran: this.radioSelect,
            });
          } else {
            await this.$store.dispatch("getRegistar", {
              page: 1,
              search: this.searchRad,
              verificiran: "",
            });
          }
          this.closeCreateDialog();

          this.openStep = 1;
        });
      }).apply(this);
    },
    async edit() {
      let noviRad = {};
      let relations = {};
      let autori = {}
      Object.assign(noviRad, {
        naslov: this.getNoviRad.naziv,
        sazetak: this.getNoviRad.sazetak,
        godina: this.getNoviRad.godina,
      });
      if (this.getVrsta) {
        Object.assign(noviRad, {vrsta_rada_id: this.getVrsta.id});
      }
      if (this.getKreiranoIzdanje) {
        Object.assign(noviRad, {
          izdanje_id: this.getKreiranoIzdanje.id,
        });
      }

      let kljucne_rijeci = {
        method: "sync",
      };
      //
      let linkovi = {
        method: "createMany",
      };
      if (this.getOdabraneKljucneRijeci.length > 0) {
        Object.assign(kljucne_rijeci, {
          method: "sync",
        });
        let data = [];
        this.getOdabraneKljucneRijeci.forEach((kr) => {
          data.push(kr.id);
        });

        Object.assign(kljucne_rijeci, {
          data: data,
        });
        Object.assign(relations, {
          kljucneRijeci: kljucne_rijeci,
        });
      }

      if (this.getLinkovi.length > 0) {
        let data = [];

        this.getLinkovi.forEach((link) => {
          if (!Object.prototype.hasOwnProperty.call(link, "id")) {
            data.push({
              opis_linka: link.opis_linka,
              link: link.link,
            });
          }
        });

        Object.assign(linkovi, {
          data: data,
        });
        Object.assign(relations, {
          linkovi: linkovi,
        });
      }
      let prijevodiRada = {
        method: "createMany",
      };
      if (this.getPrevodi.length > 0) {
        let data = [];

        this.getPrevodi.forEach((prevod) => {
          if (!Object.prototype.hasOwnProperty.call(prevod, "id")) {
            data.push({
              jezik_id: prevod.jezik_id,
              naslov: prevod.naslov,
              sazetak: prevod.sazetak,
            });
          }
        });

        Object.assign(prijevodiRada, {
          data: data,
        });

        Object.assign(relations, {
          prijevodi: prijevodiRada,
        });
      }
      let dokumentiRada = {
        method: "attach",
      };

      if (this.getFileIds.length) {
        let data = [];

        this.getFileIds.forEach((doc) => {
          data.push(doc);
        });

        Object.assign(dokumentiRada, {
          data: data,
        });

        Object.assign(relations, {
          dokumenti: dokumentiRada,
        });
      }

      if (this.getNovoIzdanje) {
        let izdanje = {
          method: "sync",
          data: {
            naziv: this.getNovoIzdanje.name,
            issn: this.getNovoIzdanje.issn,
            isbn: this.getNovoIzdanje.isbn,
          },
        };
        if (this.getNovoIzdanje.issn !== "0" && this.getIssn !== "") {
          Object.assign(noviRad, {
            issn: this.getIssn,
          });
        }
        if (this.getNovoIzdanje.isbn !== "0" && this.getIsbn !== "") {
          Object.assign(noviRad, {
            isbn: this.getIsbn,
          });
        }
        if (
            this.getNovoIzdanje.mjesto_izdavanja !== "0" &&
            this.getMjesto_izdavanja !== ""
        ) {
          Object.assign(noviRad, {
            mjesto_izdavanja: this.getMjesto_izdavanja,
          });
        }
        if (this.getNovoIzdanje.urednik !== "0" && this.getUrednik !== "") {
          Object.assign(noviRad, {
            urednik: this.getUrednik,
          });
        }
        if (this.getNovoIzdanje.broj !== "0" && this.getBroj !== "") {
          Object.assign(noviRad, {
            broj: this.getBroj,
          });
        }
        if (
            this.getNovoIzdanje.relevantnost !== "0" &&
            this.getRelevantnost !== ""
        ) {
          Object.assign(noviRad, {
            relevantnost: this.getRelevantnost,
          });
        }
        if (
            this.getNovoIzdanje.znanstvena_publikacija !== "0" &&
            this.getZnanstvena_publikacija !== ""
        ) {
          Object.assign(noviRad, {
            znanstvena_publikacija: this.getZnanstvena_publikacija,
          });
        }
        Object.assign(relations, {
          izdanje: izdanje,
        });
      }
      if (this.getTip) {
        if (this.getTip.doi && this.getDoi !== "") {
          Object.assign(noviRad, {
            doi: this.getDoi,
          });
        }
        if (this.getTip.datum_izlozbe && this.getDatumIzlozbe !== "") {
          Object.assign(noviRad, {
            datum_izlozbe: this.getDatumIzlozbe,
          });
        }
        if (this.getTip.mjesto_izlozbe && this.getMjestoIzlozbe !== "") {
          Object.assign(noviRad, {
            mjesto_izlozbe: this.getMjestoIzlozbe,
          });
        }
        if (this.getTip.datum_obrane && this.getDatumObrane !== "") {
          Object.assign(noviRad, {
            datum_obrane: this.getDatumObrane,
          });
        }
      }
      if (this.getNovaVrsta === "" && this.getVrsta) {
        Object.assign(noviRad, {
          vrsta_rada_id: this.getVrsta.id,
        });
      }
      if (this.getSelectedPodrucja.length > 0) {
        let znanstvenaPodrucja = {
          method: "sync",
        };
        let data = [];
        let singleSelects = [];
        var grouped = _.mapValues(
            _.groupBy(this.getSelectedPodrucja, "pripada_id"),
            (clist) => clist.map((podr) => _.omit(podr, "pripada_id"))
        );
        let middlePodrucja = [];
        Object.keys(grouped).forEach((pripada) => {
          let podrucje = this.getSvaZnanstvenaPodrucja.find(
              (p) => p.id == pripada
          );
          if (
              podrucje &&
              podrucje.children.length === grouped[pripada].length
          ) {
            if (!middlePodrucja.includes(podrucje)) {
              middlePodrucja.push(podrucje);
            }
          } else {
            singleSelects = singleSelects.concat(grouped[pripada]);
          }
        });
        var groupedMiddle = _.mapValues(
            _.groupBy(middlePodrucja, "pripada_id"),
            (clist) => clist.map((podr) => _.omit(podr, "pripada_id"))
        );
        let mainPodrucja = [];
        Object.keys(groupedMiddle).forEach((main) => {
          let podrucje = this.getSvaZnanstvenaPodrucja.find(
              (p) => p.id == main
          );
          if (
              podrucje &&
              podrucje.children.length === groupedMiddle[main].length
          ) {
            if (!mainPodrucja.includes(podrucje)) {
              mainPodrucja.push(podrucje);
            }
          } else {
            singleSelects = singleSelects.concat(groupedMiddle[main]);
          }
        });
        if (singleSelects.length) {
          mainPodrucja = mainPodrucja.concat(singleSelects);
        }
        if (mainPodrucja.length) {
          mainPodrucja.map((podr) => {
            if (!data.includes(podr.id)) {
              data.push(podr.id);
            }
          });
        }

        Object.assign(znanstvenaPodrucja, {
          data: data,
        }),
            Object.assign(relations, {
              znanstvenaPodrucja: znanstvenaPodrucja,
            });
      }

      if (this.getOdabraniUposleniciAutori.length > 0) {
        let authors = {};
        this.getOdabraniUposleniciAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          Object.assign(authors, {
            [autor.id]: autorId,
          });
        });
        let uposleniciAutori = {
          method: "sync",
          data: authors
        };
        // Object.assign(relations, {
        //   uposleniciAutori: uposleniciAutori,
        // });
        Object.assign(autori, {
          uposleniciAutori: uposleniciAutori,
        });
      }
      if (this.getOdabraniStudentAutori.length > 0) {
        let authors = {};
        this.getOdabraniStudentAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          Object.assign(authors, {
            [autor.id]: autorId,
          });
        });
        let studentAutori = {
          method: "sync",
          data: authors,
        };

        // Object.assign(relations, {
        //   studentiAutori: studentAutori,
        // });
        Object.assign(autori, {
          studentiAutori: studentAutori,
        });
      }
      if (this.getOdabraniStraniAutori.length > 0) {
        let authors = {};
        this.getOdabraniStraniAutori.forEach((autor) => {
          let autorId = {
            poredak: autor.redBr,
          };
          Object.assign(authors, {
            [autor.id]: autorId,
          });
        });
        let straniAutori = {
          method: "sync",
          data: authors,
        };

        // Object.assign(relations, {
        //   straniAutori: straniAutori,
        // });
        Object.assign(autori, {
          straniAutori: straniAutori,
        });
      }

      Object.assign(noviRad, {
        relations: relations,
      });
      Object.assign(noviRad, {
        autori: autori,
      });
      waitFor("radAction", async function () {
        Object.assign(noviRad, {id: this.getOdabraniRad.id});
        Object.assign(noviRad, {
          verificiran: this.getVerificiran,
        });

        this.$store.dispatch("editRad", noviRad).then(() => {
          waitFor("getRadovi", async function () {
            this.closeCreateDialog();
            this.goToRad(noviRad);
            if (this.radioSelect < 2) {
              await this.$store.dispatch("getRegistar", {
                page: 1,
                search: this.searchRad,
                verificiran: this.radioSelect,
              });
            } else {
              await this.$store.dispatch("getRegistar", {
                page: 1,
                search: this.searchRad,
                verificiran: "",
              });
            }
          }).apply(this);
          this.resetStepper();
        });
      }).apply(this);
    },
    resetStepper() {
      this.openStep = 1;
    },
  },
  mounted() {
  },
  beforeMount() {
    this.radioSelect = !this.hasAdminRights ? "1" : "2";
    waitFor("getRadovi", async function () {
      await this.$store.dispatch("getRegistar", {
        page: 1,
        search: "",
        verificiran: "",
      // !this.hasAdminRights ? 1 : ""
    });
    }).apply(this);
  },
};
</script>
<style lang="scss">
.v-data-table > .v-data-table__wrapper > table tr {
  cursor: pointer !important;
}

.podrucje {
  display: block;
}

.podrucje:first-letter {
  text-transform: uppercase;
}
</style>
